import { MONTHS } from "@/lib/format";

const f = (v, item) => {
  if (v === null || v === undefined) return "-";
  if (item.driver === "stat_occupancy" || item.is_ratio) return `${(v * 100).toFixed(2)}%`;
  return Math.round(v).toLocaleString("en-US");
};

export const BasisStrip = ({ item, basis, value, detail, slug }) => {
  if (!item) return null;
  const isAbs = detail?.mode === "abs";
  const monthly = detail?.monthly;
  const growthAt = (i) => {
    const raw = monthly && monthly[i] !== null && monthly[i] !== undefined && monthly[i] !== "" ? Number(monthly[i]) : Number(value);
    return Number.isFinite(raw) ? raw : 0;
  };
  const implied = (i) => {
    const base = item.fy[i];
    if (base === null || base === undefined) return null;
    if (isAbs) {
      const t = growthAt(i);
      if (!t) return null;
      return item.driver === "stat_occupancy" && Math.abs(base) <= 1.5 ? t / 100 : t;
    }
    return base * (1 + growthAt(i) / 100);
  };
  const impliedVals = Array.from({ length: 12 }, (_, i) => implied(i)).filter((x) => x !== null);
  const impliedTotal = impliedVals.length ? (item.avg_type ? impliedVals.reduce((a, b) => a + b, 0) / impliedVals.length : impliedVals.reduce((a, b) => a + b, 0)) : null;
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/70 p-2.5 text-[11px]" data-testid={`assumption-basis-${slug}`}>
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <p className="text-slate-600"><span className="font-semibold text-slate-800">{item.label}</span> <span className="text-slate-400">· {item.sheet} · {basis.actual_year}</span></p>
        <p className="font-mono text-slate-700">
          YTD <b data-testid={`basis-ytd-${slug}`}>{f(item.ytd_actual, item)}</b> · FY est <b data-testid={`basis-fy-${slug}`}>{f(item.fy_total, item)}</b>
          {item.ly_total !== null && item.ly_total !== undefined && <> · LY {f(item.ly_total, item)}</>}
          {impliedTotal !== null && <> → <span className="text-emerald-700 font-semibold" data-testid={`basis-implied-${slug}`}>Budget {basis.budget_year} {f(impliedTotal, item)}</span></>}
        </p>
      </div>
      <div className="mt-1.5 grid grid-cols-6 sm:grid-cols-12 gap-1">
        {MONTHS.map((m, i) => {
          const isAct = i < basis.last_actual_month && item.actual[i] !== null;
          const isDerived = isAct && item.derived?.[i];
          const imp = implied(i);
          return (
            <div key={m} className={`rounded px-1 py-0.5 text-center ${isAct ? "bg-white border border-slate-200" : "bg-amber-50 border border-amber-100"}`} data-testid={`basis-month-${slug}-${i + 1}`} title={isDerived ? "Estimated from the YTD figure of the latest report (seasonal spread) — upload this month's P&L report for the real figure" : undefined}>
              <p className="text-[9px] uppercase tracking-wider text-slate-400">{m}{isAct ? (isDerived ? " ≈" : "") : "*"}</p>
              <p className={`font-mono ${isAct ? (isDerived ? "text-slate-500 italic" : "text-slate-800") : "text-amber-800 italic"}`}>{f(item.fy[i], item)}</p>
              {imp !== null && <p className="font-mono text-emerald-700">{f(imp, item)}</p>}
            </div>
          );
        })}
      </div>
      <p className="mt-1 text-[10px] text-slate-400">Top row: actual {basis.actual_year} (* = forecast{item.derived?.some(Boolean) ? ", ≈ = estimated from the YTD figure — not a reported month" : ""}). Green: resulting budget {basis.budget_year} with the growth{monthly ? " per month" : ""} entered above.</p>
    </div>
  );
};
